const CM_PER_INCH = 2.54;

export type Quarter = 0 | 1 | 2 | 3;

export interface InchParts {
  whole: number;
  quarter: Quarter;
}

export function inchToParts(inch: number, rounding: 'nearest' | 'floor' | 'ceil' = 'nearest'): InchParts {
  if (!Number.isFinite(inch)) return { whole: 0, quarter: 0 };

  const scaled = inch * 4;
  const roundedScaled =
    rounding === 'floor' ? Math.floor(scaled) : rounding === 'ceil' ? Math.ceil(scaled) : Math.round(scaled);

  const whole = Math.floor(roundedScaled / 4);
  const quarter = (roundedScaled % 4) as Quarter;

  return { whole, quarter };
}

export function cmToInchParts(cm: number, rounding: 'nearest' | 'floor' | 'ceil' = 'nearest'): InchParts {
  const inch = cm / 2.54;

  if (!Number.isFinite(inch)) {
    return { whole: 0, quarter: 0 };
  }

  let whole = Math.floor(inch);
  const frac = inch - whole;
  let quarter: Quarter = 0;

  if (rounding === 'ceil') {
    if (frac > 0.75) {
      whole += 1;
      quarter = 0;
    } else if (frac > 0.5) {
      quarter = 3;
    } else if (frac > 0.25) {
      quarter = 2;
    } else if (frac > 0) {
      quarter = 1;
    } else {
      quarter = 0;
    }

    return { whole, quarter };
  }

  let quarters: number;
  if (rounding === 'floor') {
    quarters = Math.floor(inch * 4 + 1e-6);
  } else {
    quarters = Math.round(inch * 4);
  }

  whole = Math.floor(quarters / 4);
  quarter = (quarters % 4) as Quarter;

  return { whole, quarter };
}

export function inchPartsToInch(p: InchParts): number {
  return p.whole + p.quarter / 4;
}

export function inchPartsToCmRoundUp(p: InchParts): number {
  return inchPartsToInch(p) * CM_PER_INCH;
}
